module.exports = __webpack_public_path__ + "static/media/kop_surat.dcc09c5a.png";